/** Sidebar width in pixels */
export const SIDEBAR_WIDTH = 480;
/**
 * 5.625rem (90px) is the height of header on large screens
 */
export const KOMPIS_HEADER_HEIGHT = '5.625rem';
export const UPPTACKA_HEADER_HEIGHT = '152px';
/** The factor with which to scale the UI when in kiosk mode */
export const KIOSK_SCALING_MULTIPLIER = 1.3;
/** The factor with which to scale the UI when in upptacka mode */
export const UPPTACKA_KIOSK_SCALING_MULTIPLIER = 1.14;
/** The percentage with which to scale the UI when in kiosk mode */
export const KIOSK_SCALING_PERCENTAGE = KIOSK_SCALING_MULTIPLIER * 100;
/** The percentage with which to scale the UI when in kiosk mode */
export const UPPTACKA_KIOSK_SCALING_PERCENTAGE = UPPTACKA_KIOSK_SCALING_MULTIPLIER * 100;
//# sourceMappingURL=constants.js.map